import { IState } from '../../store';

export const offerChatSelector = (state: IState) => state.offerChat;
